import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GenerateGroupedGeneralOrdersReportInput } from './../GenerateGroupedGeneralOrdersReport/GenerateGroupedGeneralOrdersReportInput';
import { GetOrderIdsForGroupedGeneralReportOutput } from './GetOrderIdsForGroupedGeneralReportOutput';

export class GetOrderIdsForGroupedGeneralReportService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateGroupedGeneralOrdersReportInput): Promise<Result<GetOrderIdsForGroupedGeneralReportOutput> | null> => {
    const promise = this.http.post<Result<GetOrderIdsForGroupedGeneralReportOutput>, GenerateGroupedGeneralOrdersReportInput>(
      `${this.baseUrlSislogApi}/v2/report-grouped-general-orders/order-ids`,
      input);
    return promise;
  }
}